import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { CommoditiesResponse } from './commodity.model';

@Injectable({
  providedIn: 'root',
})
export class CommoditiesService extends Query<CommoditiesResponse> {
  document = gql`
    query Commodities($market: Market!, $origin: String) {
      commodities(market_type: $market, origin: $origin) {
        _id
        origin
        commodity
        market_types
        order
        price_types
        basis_product_code
        product_types {
          product_type
          market_types
          grades_conditions {
            grade
            market_types
            specifications {
              title
              #type
              order
              defaultValue
              isRequired
            }
          }
        }
      }
    }
  `;
}
